import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonBase, Stack, Typography } from "@mui/material";
import { useModifyDayMealsButton } from "./useModifyDayMealsButton";
export const ModifyDayMealsButton = (props) => {
    const { buttonText, isMobile, handleClick } = useModifyDayMealsButton(props);
    // If there is no button text, there are also no conditions met for a button action.
    if (!buttonText)
        return null;
    return (_jsx(Stack, Object.assign({ direction: "row", justifyContent: isMobile ? "flex-start" : "flex-end", marginBottom: 1, marginTop: { xx: 0.25, md: 0 }, pr: 1 }, { children: _jsx(ButtonBase, Object.assign({ type: "button", onClick: handleClick() }, { children: _jsx(Typography, Object.assign({ variant: "body2", color: "primary", sx: { textDecoration: "underline" } }, { children: buttonText })) })) })));
};
